The name of a person including a breakdown of name components.
